import { render } from "./multiLanguage2.vue?vue&type=template&id=5fc7a4e0"
import script from "./multiLanguage2.vue?vue&type=script&lang=js"
export * from "./multiLanguage2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__